import { render, staticRenderFns } from "./waschepacket.vue?vue&type=template&id=66ba487c&"
import script from "./waschepacket.vue?vue&type=script&lang=js&"
export * from "./waschepacket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66ba487c')) {
      api.createRecord('66ba487c', component.options)
    } else {
      api.reload('66ba487c', component.options)
    }
    module.hot.accept("./waschepacket.vue?vue&type=template&id=66ba487c&", function () {
      api.rerender('66ba487c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8AcmlQw3fHX0p/JS/comp/waschepacket.vue"
export default component.exports